<template>
  <div class="my_edit_btn lineControl" :class="tabName==='style'?'styleContent':'animateContent'" @click="changeStyle" :title="title?title:baseTitle">
    <span :class="tabName === 'style' ? 'el-icon-edit' : 'el-icon-magic-stick'"></span>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_edit_btn',
  data() {
    return {
      baseTitle:this.tabName ==='style'? i18n.t('widgets_basic_article_classification_edit_2980'):i18n.t('widgets_basic_article_classification_edit_330')
    };
  },
  props:{
    module: {
      type: Object,
      default: null
    },
    tabName: {
      type: String,
      default: 'style'
    },
    coverClick: { // 覆盖默认点击事件
      type: Boolean,
      default: false
    },
    title:{
      type:String,
      default:''
    }
  },
  methods:{
    changeStyle() {
      if (!this.coverClick) this.templet.changeStyle(this.module,this.tabName);
      if (this.coverClick) this.$emit('click')
    }
  }
};
</script>

<style lang="scss" scoped>
.my_edit_btn:hover {
  background-color: #2e343B;
}
</style>



// WEBPACK FOOTER //
// src/components/my_edit_btn/index.vue